/** A shipped prompt suggestion's PRs (PROC-266), named as Review draft's
 *  PR dialog names them. */
export const SuggestionPRLinks: React.FC<{ pipelinesUrl: string; apiDjangoUrl: string }> = ({
  pipelinesUrl,
  apiDjangoUrl,
}) => (
  <span className="flex flex-wrap items-center gap-x-3 text-xs text-text-secondary">
    PR opened:
    <a href={pipelinesUrl} target="_blank" rel="noopener noreferrer" className="underline hover:text-text-primary">
      Pipelines PR
    </a>
    {apiDjangoUrl ? (
      <a href={apiDjangoUrl} target="_blank" rel="noopener noreferrer" className="underline hover:text-text-primary">
        api-django PR
      </a>
    ) : null}
  </span>
);
